import { render, staticRenderFns } from "./CustomHome.vue?vue&type=template&id=ad8a7a96&scoped=true&"
import script from "./CustomHome.vue?vue&type=script&lang=js&"
export * from "./CustomHome.vue?vue&type=script&lang=js&"
import style0 from "./CustomHome.vue?vue&type=style&index=0&id=ad8a7a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8a7a96",
  null
  
)

export default component.exports